import { create } from 'zustand';

export const useStore = create((set) => ({
  // Auth
  user: JSON.parse(localStorage.getItem('smalblu_user') || 'null'),
  token: localStorage.getItem('smalblu_token'),

  setUser: (user) => {
    localStorage.setItem('smalblu_user', JSON.stringify(user));
    set({ user });
  },

  setToken: (token) => {
    localStorage.setItem('smalblu_token', token);
    set({ token });
  },

  logout: () => {
    localStorage.removeItem('smalblu_token');
    localStorage.removeItem('smalblu_user');
    localStorage.removeItem('smalblu_active_tenant');
    set({ user: null, token: null, tenants: [], activeTenantId: null });
  },

  // Multi-tenancy
  tenants: [],
  activeTenantId: localStorage.getItem('smalblu_active_tenant') || null,

  setTenants: (tenants) => set({ tenants }),

  setActiveTenant: (tenantId) => {
    localStorage.setItem('smalblu_active_tenant', tenantId);
    set({ activeTenantId: tenantId });
  },

  // Sidebar
  sidebarOpen: true,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  // Time range filter
  selectedTimeRange: '24h',
  setTimeRange: (range) => set({ selectedTimeRange: range }),
}));
